// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ApolloClient = require("apollo-client");
var ReasonApolloQuery = require("./graphql-types/ReasonApolloQuery.bs.js");
var ReasonApolloMutation = require("./graphql-types/ReasonApolloMutation.bs.js");
var ReasonApolloSubscription = require("./graphql-types/ReasonApolloSubscription.bs.js");

function createApolloClient(link, cache, ssrMode, ssrForceFetchDelay, connectToDevTools, queryDeduplication, param) {
  return new ApolloClient.ApolloClient({
              link: link,
              cache: cache,
              ssrMode: ssrMode,
              ssrForceFetchDelay: ssrForceFetchDelay,
              connectToDevTools: connectToDevTools,
              queryDeduplication: queryDeduplication
            });
}

var CreateQuery = ReasonApolloQuery.Make;

var CreateMutation = ReasonApolloMutation.Make;

var CreateSubscription = ReasonApolloSubscription.Make;

var Provider;

var Consumer;

exports.createApolloClient = createApolloClient;
exports.CreateQuery = CreateQuery;
exports.CreateMutation = CreateMutation;
exports.CreateSubscription = CreateSubscription;
exports.Provider = Provider;
exports.Consumer = Consumer;
/* apollo-client Not a pure module */
